import StyleSheetRW from "core/StyleSheetRW";
import { Text } from "react-native";
import { View } from "react-native";


const ProgressCircle: React.FC<{ score: number }> = ({ score }) => {
    const size = 60;
    const strokeWidth = 5;
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (score / 100) * circumference;

    return (
        <View style={styles.progressContainer}>
            <svg height={size} width={size} style={{ transform: [{ rotate: '-90deg' }] }}>
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke="black"
                    strokeWidth={strokeWidth}
                    fill="none"
                    strokeDasharray={circumference}
                    strokeDashoffset={0}
                    style={{ opacity: 0.2 }}
                />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke={score === 0 ? 'red' : 'green'}
                    strokeWidth={strokeWidth}
                    fill="none"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                />
            </svg>
            <Text style={styles.progressText}>{score}%</Text>
        </View>
    );
};
const styles = StyleSheetRW.create(() => ({
    progressContainer: { justifyContent: 'center', alignItems: 'center', position: 'relative', width: 60, height: 60 },
    progressWrapper: { width: 60, height: 60, justifyContent: 'center', alignItems: 'center', marginLeft: 40 },
    progressText: { position: 'absolute', fontSize: 16, fontWeight: 'bold', textAlign: 'center', width: '100%', lineHeight: 60 },

}))
export default ProgressCircle